// extracted by mini-css-extract-plugin
export var blue = "_16-f";
export var brand = "_16-b";
export var darkGrey = "_16-e";
export var disabled = "_16-4";
export var disabledSubtle = "_16-5";
export var error = "_16-6";
export var green = "_16-g";
export var grey = "_16-d";
export var icon = "_16-0";
export var inherit = "_16-a";
export var lightGrey = "_16-c";
export var orange = "_16-i";
export var pink = "_16-k";
export var primary = "_16-1";
export var purple = "_16-l";
export var red = "_16-j";
export var secondary = "_16-2";
export var success = "_16-9";
export var tertiary = "_16-3";
export var warning = "_16-7";
export var warningSecondary = "_16-8";
export var white = "_16-m";
export var yellow = "_16-h";